module.exports = __webpack_public_path__ + "static/img/homomorphic-encryption.634f05ec.png";